import { render, staticRenderFns } from "./description-partial.vue?vue&type=template&id=70f570fe"
import script from "./description-partial.vue?vue&type=script&lang=js"
export * from "./description-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports